import { Button, FormContentIsland, Grid, HookForm, SwitchField } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { useCardSecurityQuery, useCardUpdateSecurityMutation } from '../../../api/cards';
import { useCallback, useEffect } from 'react';
import { Route } from '../../../routes/account.cards_.$cardId_.security';
import { MainLayout } from '../../Layout/MainLayout';
import { MainBreadcrumbs } from '../../Layout/MainBreadcrumbs';
import { useForm } from 'react-hook-form';
import { ApiCardUpdateSecurityRequest } from '../../../openapi';
import { useFormError } from '../../../hooks/useFormError';
import { useCardQuery } from '../../../api/cards';

type CardSecurityFormValues = ApiCardUpdateSecurityRequest;

export function CardSecurityPage() {
  const { t } = useTranslation();
  const { cardId } = Route.useParams();
  const cardQuery = useCardQuery({ cardId });
  const securityQuery = useCardSecurityQuery({ cardId });
  const mutation = useCardUpdateSecurityMutation(cardId);

  const form = useForm<CardSecurityFormValues>({
    defaultValues: cardQuery.data?.securityPolicy,
  });

  useFormError(form, 'atm', mutation.error);

  useEffect(() => {
    const policy = securityQuery.data?.securityPolicy;
    if (policy) {
      form.reset(policy);
    }
  }, [securityQuery.data, form]);

  const handleSubmit = useCallback(
    (values: CardSecurityFormValues) => {
      mutation.mutate(values);
    },
    [mutation],
  );

  return (
    <HookForm form={form} onSubmit={handleSubmit}>
      <MainLayout
        title={
          <MainBreadcrumbs
            title={t('Card security')}
            parent={{
              to: '/account/cards/$cardId',
              params: { cardId },
              title: cardQuery.data?.name,
              loading: cardQuery.isPending,
            }}
          />
        }
        compact
      >
        <Grid size={12}>
          <FormContentIsland title={t('Security settings')}>
            <SwitchField
              name="contactless"
              label={t('Contactless transactions')}
              helperText={t('Allow services that use NFC, such as Google Pay, to access this card')}
            />
            <SwitchField
              name="internet"
              label={t('Internet transactions')}
              helperText={t(
                'Allow card payments in online stores, for online subscription services and similar',
              )}
            />
            {/* <SwitchField
              name="ecommerce"
              label={t('E-commerce transactions')}
              helperText={t('Allow online purchases using this card')}
            /> */}
            <SwitchField
              name="atm"
              label={t('ATM withdrawals')}
              helperText={t('Allow physical cash withdrawals using this card')}
            />
          </FormContentIsland>
        </Grid>
        <Grid size={12}>
          <Button
            type="submit"
            size="large"
            color="primary"
            loading={mutation.isPending}
            disabled={!form.formState.isDirty}
            fullWidth
          >
            {t('Update')}
          </Button>
        </Grid>
      </MainLayout>
    </HookForm>
  );
}
